// extracted by mini-css-extract-plugin
export var linkText = "_li-0";